import { combineReducers } from "@reduxjs/toolkit";
import checkInSlice from "./checkin/checkinSlice";
import addPassengerSlice from "./checkin/addPassengerSlice";
import cancelCheckin from "./cancelCheckin/cancelCheckinSlice";
import cancelRetrieveCheckinSlice from "./cancelCheckin/cancelRetrieveJourneySlice";
import removeSelectPassengerCheckinSlice from "./checkin/removeSelectPassengerSlice";
import selectPassengerSlice from "./checkin/selectPassengerDetailsSlice";
import fetchFrequentFlyerProgramSlice from "./checkin/passengerDetails/frequentFlyerProgramSlice";
import updatedPassengerSlice from "./checkin/updatePassengerDetailsSlice";
import nationalityCountrySlice from "./checkin/passengerDetails/nationalityCountrySlice";
import fetchAutoSeatSlice from "./checkin/autoSeatSlice";
import seatMapSlice from "./seatMap/seatMapSlice";
import fetchCheckinBoardingPassSlice from "./checkin/checkinBoardingPassSlice";
import completeCheckinSlice from "./checkin/completeCheckin/completeCheckinSlice";
import dangerousGoodsSlice from "./checkin/dangerousGoodsSlice";
import ffpGenerateOtpSlice from "./checkin/passengerDetails/ffpGenerateOtpSlice";
import fetchRegulatorySlice from "./checkin/passengerDetails/regulatorySlice";
import fetchCountryListSlice from "./checkin/passengerDetails/countryListSlice";
import errorCodeSlice from "./checkin/checkinErrorCodeSlice";
import flightLayoutSlice from "./seatMap/flightLayoutSlice";
import seatCharacteristicsSlice from "./seatMap/seatCharacteristicsSlice";
import fetchPassportCountryValiditySlice from "./checkin/passengerDetails/passportValiditySlice";
import samsungSlice from "./checkin/samsungSlice";
import fetchDestinationSlice from "./checkin/destinationBannerSlice";
import fetchExitRowSlice from "./checkin/exitRow/exitRowSlice";
import fetchRopJoinNow from "./checkin/joinNowSlice";
import updateExitRowSlice from "./checkin/exitRow/updateExitRowSlice";
import flightLayoutList from "./seatMap/avaliableFlightSlice";
import airlineNamesSice from "./checkin/airlinesSlice";
import rollOutSlice from "./checkin/marketRolloutSlice";
import purhcaseSlice from "./travel-insurance/purchaseSlice";
import insuranceQuotationSlice from "./travel-insurance/insuranceQuotationSlice";
import insurancePaymentSlice from "./travel-insurance/paymentSlice";
import configSlice from "./checkin/checkinConfigSlice";
import checkinAgreementSlice from "./checkin/checkinAgreementSlice";
import orderRetrieveSlice from "./orderRetrieveSlice/retrieveSlice";
import travelInsuranceSlice from "./travel-insurance/travelInsuranceSlice";
import termsandconditionSlice from "./travel-insurance/termsandConditionSlice";
import airportNameSlice from "./checkin/airportNameSlice";
import cityCodeNameSlice from "./checkin/cityCodeSlice";
import deviceNameSlice from "./deviceNameSlice";
import ancillarySlice from "./checkin/ancillarySlice";
import flightListReducer from "./flightListSlice";
import usersReducer from "../../../OSCI/src/slice/userList";
import shoppingCartSlice from "../../../OSCI/src/slice/shoppingCartSlice";
const RootReducer = combineReducers({
  checkin: checkInSlice,
  addPassenger: addPassengerSlice,
  cancelCheckin: cancelCheckin,
  cancelRetreiveCheckin: cancelRetrieveCheckinSlice,
  removeSelectPassenger: removeSelectPassengerCheckinSlice,
  selectPassenger: selectPassengerSlice,
  frequentFlyerProgram: fetchFrequentFlyerProgramSlice,
  updatePassenger: updatedPassengerSlice,
  nationalityCountry: nationalityCountrySlice,
  autoSeat: fetchAutoSeatSlice,
  seatMapResponse: seatMapSlice,
  checkinBoardingPass: fetchCheckinBoardingPassSlice,
  completeCheckin: completeCheckinSlice,
  dangerousGoods: dangerousGoodsSlice,
  ffpGenerateOtp: ffpGenerateOtpSlice,
  regulatoryJson: fetchRegulatorySlice,
  countryList: fetchCountryListSlice,
  errorCodeJson: errorCodeSlice,
  flightLayout: flightLayoutSlice,
  seatCharacteristics: seatCharacteristicsSlice,
  passportValidity: fetchPassportCountryValiditySlice,
  samsungWallet: samsungSlice,
  destinationList: fetchDestinationSlice,
  exitRow: fetchExitRowSlice,
  ropJoin: fetchRopJoinNow,
  updateExitRow: updateExitRowSlice,
  flightLayoutList: flightLayoutList,
  airlinesList: airlineNamesSice,
  rolloutMarket: rollOutSlice,
  purhcaseSlice: purhcaseSlice,
  insuranceQuotation: insuranceQuotationSlice,
  insurancePayment: insurancePaymentSlice,
  configSlice: configSlice,
  checkinAgreement: checkinAgreementSlice,
  retrieveOrder: orderRetrieveSlice,
  travelInsurance: travelInsuranceSlice,
  termsandConditions: termsandconditionSlice,
  airportNames: airportNameSlice,
  cityNames: cityCodeNameSlice,
  deviceSlice: deviceNameSlice,
  ancillaryList: ancillarySlice,
  flightList: flightListReducer,
  users: usersReducer,
  addShoppingCart: shoppingCartSlice
});
export default RootReducer;